import { TournamentReward as TournamentRewardType, TournamentRewardTypeEnum } from 'config/types/tournament'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Text, { TextProps } from 'UIKit/Text'
import HunnyTooltip from 'UIKit/Tooltip'

type TournamentRewardProps = {
  rewardDetails: TournamentRewardType
  isDisplayTooltip?: boolean
  tooltipId?: string
}

const TournamentReward: React.FC<TournamentRewardProps & TextProps> = ({
  rewardDetails,
  isDisplayTooltip = false,
  tooltipId,
  ...props
}) => {
  const { t } = useTranslation()
  const rewardBonusNameDisplay = rewardDetails.rewardType === TournamentRewardTypeEnum.Bonus && [
    t(rewardDetails.reward.bonusDetails[0]),
    rewardDetails.reward.bonusDetails[1],
  ]

  const tooltipContent =
    isDisplayTooltip &&
    (rewardDetails.rewardType === TournamentRewardTypeEnum.Cash
      ? `$${rewardDetails.reward.amountInUsd}`
      : rewardDetails.rewardType === TournamentRewardTypeEnum.Bonus &&
        `${rewardBonusNameDisplay[1]} ${rewardBonusNameDisplay[0]}`)

  const textRef = useRef<HTMLDivElement>(null)
  const isOverflowing = textRef.current?.scrollWidth > textRef.current?.clientWidth

  return (
    rewardDetails && (
      <DisplayText
        ref={textRef}
        fontWeight={800}
        letterSpacing="-0.4px"
        {...props}
        data-tooltip-id={isOverflowing && isDisplayTooltip ? tooltipId : null}
      >
        {rewardDetails.rewardType === TournamentRewardTypeEnum.Cash
          ? `$${rewardDetails.reward.amountInUsd}`
          : rewardDetails.rewardType === TournamentRewardTypeEnum.Bonus && (
              <>
                {`${rewardBonusNameDisplay[1]} `}
                <DisplayText as="span" fontWeight={600} color="textSubtle">
                  {rewardBonusNameDisplay[0]}
                </DisplayText>
              </>
            )}
        {isOverflowing && isDisplayTooltip && (
          <HunnyTooltip
            id={tooltipId}
            className="tournament-prize-tooltip"
            place="top"
            offset={6}
            style={{
              padding: '4px 12px',
              borderRadius: '6px',
            }}
          >
            <Text fontSize="14px" fontWeight={500} lineHeight="20px">
              {tooltipContent}
            </Text>
          </HunnyTooltip>
        )}
      </DisplayText>
    )
  )
}

const DisplayText = styled(Text)`
  font-weight: 600;
  font-size: 12px;
  line-height: normal;
  letter-spacing: -0.24px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
`

export default TournamentReward
